import React, { useMemo, useState } from "react";
import { UploaderScroller } from "./UploaderScroller.js";
import "./EmbedFormLogoUploader.scss";
import Icon from "../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import AvatarEditor from "react-avatar-editor";

const _URL = window.URL || window.webkitURL;

const EmbedFormLogoSelector = React.forwardRef(
  (
    {
      backgroundImage,
      image,
      size,
      handleClick,
      imageSizes,
      setImageSizes,
      cancelImage,
      setIfRemoveFromDB,
      error,
    },
    ref
  ) => {
    const { getHtmlByKey, getTextByKey } = useContent();

    //scroller scaling logic
    const [scale, setScale] = useState(1);
    const handleScale = (e) => {
      const scale = parseFloat(e.target.value);
      setScale(scale);
    };

    useMemo(() => {
      if (image) {
        const img = new Image();
        img.onload = function () {
          setImageSizes(() => ({
            valid:
              this.width > 370 &&
              this.width < 2000 &&
              this.height > 240 &&
              this.height < 2000,
            width: this.width > 400 ? 400 : this.width,
            height:
              this.width > 400 ? 400 * (this.height / this.width) : this.height,
          }));
        };
        if (typeof image !== "string") {
          const url = _URL.createObjectURL(image);
          img.src = url;
        } else {
          img.src = image;
        }
      }
    }, [image]);
    return (
      <div
        className={`form-logo-selector ${image ? "selector-with-picture" : ""}`}
      >
        <div className={`logo-picture ${image ? "with-picture" : ""}`}>
          {image && (
            <div className="actions">
              <div className="upload-image" onClick={handleClick}>
                <Icon name="camera" />
              </div>
              {image && !image.includes("form-pic") && (
                <div
                  className="delete-image"
                  onClick={() =>
                    cancelImage({ ifClose: false, ifRemove: true })
                  }
                >
                  <Icon name="trash-solid-b" />
                </div>
              )}
            </div>
          )}
          <div
            className={`logo-selector-center ${
              image ? "logo-image-selected" : ""
            }`}
          >
            {(image && !imageSizes.valid) || error ? (
              <div className="validation-size-container">
                {getHtmlByKey(
                  error ? error : "embed-form-logo-validation-size-text"
                )}
              </div>
            ) : null}
            {image ? (
              <AvatarEditor
                ref={ref}
                image={image}
                width={380}
                height={243}
                crossOrigin=""
                border={0}
                color={[255, 255, 255, 0.6]} // RGBA
                scale={parseFloat(scale)}
                rotate={0}
              />
            ) : (
              <div className="click-to-action-circle" onClick={handleClick}>
                <Icon name="cloud-upload" white></Icon>
                <span>{getTextByKey("upload-image")}</span>
              </div>
            )}
          </div>
        </div>
        {image &&
        imageSizes.valid &&
        imageSizes.width > 50 &&
        image.indexOf("https://") < 0 ? (
          <UploaderScroller
            image={image}
            handleScale={handleScale}
            maxValue={imageSizes.width / 50}
          />
        ) : null}
      </div>
    );
  }
);

export default EmbedFormLogoSelector;
